import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';
import { Author } from '@api/types.generated';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/author');

export const fetchAuthorList = actionCreator.async<{}, Author[]>('AUTHOR_LIST');
export const createAuthor = actionCreator.async<Omit<Author, 'id'>, {}>('AUTHOR_CREATE');
export const deleteAuthor = actionCreator.async<Author['id'], {}>('AUTHOR_DELETE');
export const updateAuthor = actionCreator.async<Author, Author>('AUTHOR_UPDATE');
